import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Selectors
// @ts-ignore
import { makeSelectContainerGroupValue } from 'services/containerGroups/selectors';

// Environment
const { REACT_APP_URL } = process.env;

interface OwnProps {
    containerGroupId?: number;
}

interface ConnectedProps {
    pdfUrl?: string | null;
}

type Props = OwnProps & ConnectedProps;

export class ContainerGroupPdfUrlButtonComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { pdfUrl } = this.props;
        if (!pdfUrl) {
            return null;
        }
        return (
            <Button
                primary
                href={`${REACT_APP_URL}${pdfUrl}`}
                target="_blank"
                fluid
            >
                Download
            </Button>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    pdfUrl: makeSelectContainerGroupValue('pdfUrl')
});

export default connect(mapStateToProps)(ContainerGroupPdfUrlButtonComponent);
